import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { LayoutService } from '../service/app.layout.service';
import {
  ThemeService,
  PRIMARY_COLORS,
  SURFACE_COLORS,
  PRESET_NAMES,
} from '@shared/theme';

@Component({
  selector: 'app-theme-config',
  templateUrl: './theme-config.component.html',
  styleUrl: './theme-config.component.scss',
  imports: [CommonModule, DrawerModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeConfigComponent {
  readonly layoutService = inject(LayoutService);
  readonly themeService = inject(ThemeService);

  readonly primaryColors = PRIMARY_COLORS;
  readonly surfaceColors = SURFACE_COLORS;
  readonly presetNames = PRESET_NAMES;

  onPrimarySelect(colorName: string): void {
    this.themeService.setPrimary(colorName);
  }

  onSurfaceSelect(colorName: string): void {
    this.themeService.setSurface(colorName);
  }

  onPresetSelect(presetName: string): void {
    this.themeService.setPreset(presetName);
  }
}
